import React, { Component } from "react";
import { select, selectAll } from "d3-selection";
import "d3-transition";
import arrowSvg from "../static/arrow.svg";
import svgExperiences from "../static/emoji/1f4a5.svg";
import svgLegacy from "../static/emoji/1f46a.svg";
import svgLuxury from "../static/emoji/1f48e.svg";
import svgConnected from "../static/emoji/1f91d.svg";
import svgPhilanthropy from "../static/emoji/1f333.svg";
import svgStatus from "../static/emoji/1f451.svg";
import svgNone from "../static/emoji/1f910.svg";

const svgHash = {
  "Exciting experiences": svgExperiences,
  "Legacy for family": svgLegacy,
  Luxury: svgLuxury,
  "Well connected": svgConnected,
  Philanthropy: svgPhilanthropy,
  "Social Status": svgStatus,
  "None of these": svgNone
};

const rowSpace = 40;

const Question = () =>
  <div className="question">
    The most important forms of wealth for millennials and their parents
    <style jsx>{`
      .question {
        color: #444;
        font-family: FrutigerLTCom;
        font-weight: 300;
        font-size: 24px;
        line-height: 32px;
        text-align: center;
        margin: 0 0 16px 0;
        width: 100%;
      }
      @media screen and (max-width : 768px) {
          .question {
               font-size: 16px;
               line-height: 24px;
               text-align: left;
          }
      }
    `}</style>
  </div>;

class Controls extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      group: "millennials"
    };
  }

  handleChange(event) {
    this.props.onChange(event.target.value);
  }

  render() {
    const isMobile = this.props.width < 768;

    return (
      <div className="controls-container">
        <div className="controls">
          <form>
            <select value={this.props.country} onChange={this.handleChange}>
              <option value="All countries">All countries</option>
              <optgroup label="Markets: ">
                <option value="Emerging markets">Emerging markets</option>
                <option value="Developed markets">Developed markets</option>
              </optgroup>
              <optgroup label="Countries: ">
                <option value="United States">United States</option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="Germany">Germany</option>
                <option value="Singapore">Singapore</option>
                <option value="Russia">Russia</option>
                <option value="China">China</option>
                <option value="India">India</option>
                <option value="United Arab Emirates">
                  United Arab Emirates
                </option>
                <option value="Mexico">Mexico</option>
                <option value="South Africa">South Africa</option>
              </optgroup>
            </select>
          </form>
        </div>

        {isMobile
          ? <div className="buttons">
              <button
                className={this.state.group === "millennials" ? "active" : null}
                onClick={() => this.setState({ group: "millennials" })}
              >
                Millennials
              </button>
              <button
                className={this.state.group === "parents" ? "active" : null}
                onClick={() => this.setState({ group: "parents" })}
              >
                Parents
              </button>
            </div>
          : null}

        <div className="chart-itself">
          {!isMobile
            ? <RankList
                list={this.props.answersMillennials}
                country={this.props.country}
                side="left"
              />
            : null}

            <Slope
                answersMillennials={this.props.answersMillennials}
                answersParents={this.props.answersParents}
                country={this.props.country}
              />

          <RankList
            list={
              isMobile && this.state.group === "millennials"
                ? this.props.answersMillennials
                : this.props.answersParents
            }
            country={this.props.country}
            side="right"
          />

        </div>
        <style jsx>{`
          .controls {
            padding-bottom: 24px;
            display: flex;
            justify-content: center;
            width: 100%;
          }          
          .chart-itself {
            display: flex;
            width: 100%;
          }
          select {
            width: 100%;
            margin: 20px 0 10px 0;
            padding: 10px;
            border: 1px solid #444;
            border-radius: 0;
            font-family: FrutigerLTCom;
            font-size: 14px;
            appearance: none;
            -webkit-appearance: none;
            background: url('${arrowSvg}') no-repeat right;
            background-position-x: 95%;
          }
          select:focus {
            outline: none;
          }
          select::-ms-expand {
            display: none;
          }
          .buttons {
            display: flex;
            justify-content: center;
            width: 100%;
            padding-bottom: 5px;
          }
          button {
            font-size: 14px;
            border: 1px solid #444;
            width: 50%;
            background: transparent;
            padding: 10px;
            margin: 0;
          }
          button.active {
            background: #444;
            color: #fff;
          }
          button:first-child {
            border-top-left-radius: 1px;
            border-bottom-left-radius: 1px;
          }
          button:last-child {
            border-top-right-radius: 1px;
            border-bottom-right-radius: 1px;
          }
          button:focus {
            outline: none;
          }
          @media screen and (max-width : 768px) {
            .controls {
                 padding-bottom: 8px;
            }
            form {
              width: 100%;
              display: flex;
            }
        }
        `}</style>
      </div>
    );
  }
}

class RankList extends Component {
  componentDidMount() {
    const thisNode = select(this.node);
    const listItems = thisNode.selectAll("div.rank-list-item");
    listItems.transition().duration(0).style("transform", function(d, i) {
      return "translate(0px, " + (i * rowSpace) + "px)";
    });
    
    listItems.on("mouseover", (d, i) => {
      selectAll("div.rank-list-item").style("opacity", ".3");
      selectAll("line").style("stroke-opacity", ".3");
      const val = thisNode.select("div.rank-list-item#id"+i+"").attr("value");
      selectAll("div.rank-list-item[value = \""+val+"\"]").style("opacity", "1");
      select("line[value = \""+val+"\"]").style("stroke-opacity", "1");
    });

    selectAll(".controls-container").on("mouseleave", (d, i) => {
      selectAll("div.rank-list-item").style("opacity", "1");
      selectAll("line").style("stroke-opacity", "1");
    });

  }

  componentDidUpdate() {
    const thisNode = select(this.node);
    const listItems = select(this.node).selectAll("div.rank-list-item");
    listItems.transition().duration(1000).style("transform", function(d, i) {
      return "translate(0px, " + (i * rowSpace) + "px)";
    });
    
    listItems.on("mouseover", (d, i) => {
      selectAll("div.rank-list-item").style("opacity", ".3");
      selectAll("line").style("stroke-opacity", ".3");
      const val = thisNode.select("div.rank-list-item#id"+i+"").attr("value");
      selectAll("div.rank-list-item[value = \""+val+"\"]").style("opacity", "1");
      select("line[value = \""+val+"\"]").style("stroke-opacity", "1");
    });
  }

  render() {
    const TheseAnswers = this.props.list
      .find(d => d.country === this.props.country)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });
    return (
      <div className="rank-list-container">
        <div className={
          this.props.side === "left" ? "rank-list-title rank-list-title-millennials" : "rank-list-title rank-list-title-parents"
        } >
          {this.props.side === "left" ? "Millennials" : "Parents"}
        </div>
        <div
          className="rank-list"
          ref={rankListDiv => {
            this.node = rankListDiv;
          }}
        >
          {TheseAnswers.map((d, i) => {
            return (
              <div className={this.props.side === "left"
                  ? "rank-list-item rank-list-item-left"
                  : "rank-list-item rank-list-item-right"
                }
                key={d.key}
                id={"id"+i}
                value={d.key}>
                <img
                  width="24px"
                  height="24px"
                  src={svgHash[d.key]}
                  alt={"emoji "+d.key}
                />
                <div
                  className={
                    this.props.side === "left"
                      ? "rank-label rank-label-left"
                      : "rank-label rank-label-right"
                  }>
                  {d.key}
                </div>
                <div className={"rank-number"}
                      style={{
                         textAlign: this.props.side === "left"
                              ? "right"
                              : "left"
                      }}>
                  {i + 1}
                </div>
              </div>
            );
          })}
        </div>
        <style jsx>{`
          .rank-list-container {
            flex: 1 1 0%;
          }
          .rank-list-title {
            font-family: FrutigerLTCom;
            font-weight: 700;
            padding: 0 26px 0 26px;
          }
          .rank-list-title-millennials {
            text-align: right;
          }
          .rank-list {
            position: relative;
            font-size: 14px;
            height: 280px;
            padding-top: 12px;
          }
          .rank-list-item {
            position: absolute;
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .rank-list-item-left {
            flex-direction: row;
          }
          .rank-list-item-right {
            flex-direction: row-reverse;
          }
          .rank-label {
            color: #333;
            font-family: FrutigerLTCom;
            font-size: 16px;
            font-weight: 300;
            padding: 0 10px 0 10px;
            cursor: default;
          }
          .rank-label-left {
            margin-left: auto;
          }
          .rank-label-right {
            margin-right: auto;
          }
         
          .rank-number {
            font-family: FrutigerLTCom;
            font-size: 16px;
            font-weight: 700;
            color: #807266;
            width: 16px;
          }
          @media screen and (max-width : 768px) {
            .rank-list-title {
                 display: none;
            }
            .rank-list {
                 pointer-events: none;
            }
        }
        `}</style>
      </div>
    );
  }
}

class Slope extends Component {
  componentDidMount() {
    const MillennialsAnswers = this.props.answersMillennials
      .find(d => d.country === this.props.country)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });
    const ParentsAnswers = this.props.answersParents
      .find(d => d.country === this.props.country)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });

    ParentsAnswers.forEach((d, i) => {
      d.rank = i;
    });

    const lines = select(this.node).selectAll("line");

    lines
      .transition()
      .duration(0)
      .attr("y1", function(d, i) {
        return i * rowSpace;
      })
      .attr("y2", function(d, i) {
        let ParentRank = ParentsAnswers.find(
          r => r.key === MillennialsAnswers[i].key
        );
        return ParentRank.rank * rowSpace;
      });
  }

  componentDidUpdate() {
    const MillennialsAnswers = this.props.answersMillennials
      .find(d => d.country === this.props.country)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });
    const ParentsAnswers = this.props.answersParents
      .find(d => d.country === this.props.country)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });

    ParentsAnswers.forEach((d, i) => {
      d.rank = i;
    });

    const lines = select(this.node).selectAll("line");

    lines
      .transition()
      .duration(1000)
      .attr("y1", function(d, i) {
        return i * rowSpace;
      })
      .attr("y2", function(d, i) {
        let ParentRank = ParentsAnswers.find(
          r => r.key === MillennialsAnswers[i].key
        );
        return ParentRank.rank * rowSpace;
      });
  }

  render() {
    const MillennialsAnswers = this.props.answersMillennials
      .find(d => d.country === this.props.country)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });

    return (
      <div className="slope">
        <svg className="svg-slope" width="300px" height="280px">
          <g
            className="slopes-group"
            ref={node => {
              this.node = node;
            }}
          >
            {MillennialsAnswers.map((d, i) => {
              return (
                <line
                  key={d.key}
                  value={d.key}
                  x1={20}
                  y1={0}
                  x2={280}
                  y2={0}
                  style={{ stroke: "#807266", strokeLinecap: "round", "strokeWidth": "2px" }}
                />
              );
            })}
          </g>
        </svg>
        <style jsx>{`
          svg {
            display: block;
          }
          .svg-slope {
            padding-top: 48px;
          }
           @media screen and (max-width : 768px) {
              .slope {
                display:none;
              }
          }
        `}</style>
      </div>
    );
  }
}

const Source = () => 
  <div className="source">
    Source: unlimited.world survey of affluent millennials, UBS. Data as of October 2016. N = 2,130.
  <style jsx>{`
    .source {
      font-family: FrutigerLTCom;
      width: 100%;
      font-size: 11px;
      font-weight: 300;
      color: #888;
      height: 26px;
      text-align: center;
    }
    @media screen and (max-width : 768px) {
        .source {
          text-align: left;
        }
    }
  `}
  </style>
  </div>

export default class SlopeChartWealth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      country: "All countries"
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(country) {
    this.setState({
      country: country
    });
  }

  render() {
    return (
      <div className="whole-chart">
        <Question />
        <Controls
          answersMillennials={this.props.dataMillennials}
          answersParents={this.props.dataParents}
          country={this.state.country}
          onChange={this.handleChange}
          width={this.props.width}
        />
        <Source />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SlopeChartWealth.js